import { createActionTypes } from '../_utils'

const types = {
  TOGGLE: 'TOGGLE',
  SET_LAYOUT: 'SET_LAYOUT',
  SET_APPLICATION: 'SET_APPLICATION',
  UPDATE_LOADING: 'UPDATE_LOADING',
  UPDATE_TAB_KEY: 'UPDATE_TAB_KEY',
  UPDATE_TAB_LIST: 'UPDATE_TAB_LIST',
  DELETE_TAB_ITEM: 'DELETE_TAB_ITEM',
  PUSH_CRUMB_LIST: 'CRUMB_LIST.PUSH',
  REPLACE_CRUMB_LIST: 'CRUMB_LIST.REPLACE',
  RESET_CRUMB_LIST: 'CRUMB_LIST.RESET',
  REDO_CRUMB_LIST: 'CRUMB_LIST.REDO',
  UNDO_CRUMB_LIST: 'CRUMB_LIST.UNDO',
  INIT_CRUMB_LIST: 'CRUMB_LIST.INIT',
  SET_MENU_DATA: 'SET_MENU_DATA',
  SET_SELECTED_KEYS: 'SET_SELECTED_KEYS',
  SET_OPEN_KEYS: 'SET_OPEN_KEYS',
  SET_LEVEL_PAGE: 'SET_LEVEL_PAGE',
  SET_USER: 'SET_USER',
  GET_APPLICATIONS: 'GET_APPLICATIONS',
  /*
   * LOAD COMPONENT
   * */
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_SEARCH_OBJ: 'SET_SEARCH_OBJ',
  SET_PAGE_PATH: 'SET_PAGE_PATH',
  SET_LIST: 'SET_LIST',
  UPDATE_LIST_ITEM: 'UPDATE_LIST_ITEM',
  UPDATE_LIST_ITEM_VAL: 'UPDATE_LIST_ITEM_VAL',
  DELETE_LIST: 'DELETE_LIST'
}

export default createActionTypes(types, 'LAYOUT')
